export const CONSTANTS = {
  
  API_BASE_URL: 'https://api.magman.synology.me',

  GENERIC_USER_KEY: 1006,
}
